import { FC } from "react";

import { Button } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsiveDisplayMode } from "capitalrx-components-2.0/lib/layout";
import { Form, SubmitButton } from "capitalrx-components-2.0/lib/forms";

import { PricingLevelsTypes } from "@/types";

import { PricingLevelForm } from "./PricingLevelForm";

interface Props {
  readonly defaultValues?: PricingLevelsTypes.PricingLevelBase;
  readonly handleSubmit: (values: PricingLevelsTypes.PricingLevelBase) => Promise<void>;
  readonly handleCancel: () => void;
  readonly isEditMode?: boolean;
}

export const PricingLevelFormPage: FC<Props> = ({ defaultValues, handleSubmit, handleCancel, isEditMode = false }) => {
  const displayMode = useResponsiveDisplayMode();
  const displayModeIsMobile = displayMode === "mobile";
  const FlexibleContainer = displayModeIsMobile ? Stack : Shelf;

  return (
    <Form<PricingLevelsTypes.PricingLevelBase> onSubmit={handleSubmit} defaultValues={defaultValues}>
      <Stack>
        <PricingLevelForm defaultValues={defaultValues} />
        <Stack alignment={displayModeIsMobile ? "span" : "left"}>
          <FlexibleContainer spacing="small">
            <SubmitButton testId="plan-level-form-submit-btn">Save</SubmitButton>
            <Button appearance="secondary" onClick={handleCancel} testId="plan-level-form-cancel-btn">
              Cancel
            </Button>
          </FlexibleContainer>
        </Stack>
      </Stack>
    </Form>
  );
};
